module.exports = __webpack_public_path__ + "img/italy-neoplasm-female.85b2dc02.png";